import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { changePasswordUseCase } from '../../di/usecase_module';
import { ChangePasswordRequestDto } from '../../domain/usecases/session/ChangePasswordUseCase';
import { useForm } from '../../presentation/hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { RootState } from '../../presentation/redux/store/RootState';
import { handleError } from '../../presentation/utils/handleError';
import { showSuccessMessage } from '../../presentation/utils/showSuccessMessage';
import { handleLogout } from '../../presentation/utils/handleLogout';
import Swal from 'sweetalert2';
import { InputPass as InputMvv, validatePassword } from '@movivendor/mv-components';


export const ModalChangePassword = () => {

  const dispatch = useDispatch();
  const uiState = useSelector((s: RootState) => s.uiState)
  const [values, handleInputChange, reset]: any = useForm();

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (isFormValid()) {

      if (!oldPasswordIsValid() || !newPasswordIsValid() || !confirmPasswordIsValid()) return;

      changePasswordUseCase()
        .execute(new ChangePasswordRequestDto(
          encodeURIComponent(values.oldPassword),
          encodeURIComponent(values.newPassword)
        ))
        .then((_) => {
          showSuccessMessage({
            message: "La contraseña ha sido cambiada exitosamente. Inicia sesión con tu nueva contraseña para continuar"
          }, () => {
            handleHide();
            handleLogout();
          });

        }).catch((e) => {
          handleError(e);
        })
    }
  }

  function handleHide() {
    reset({});
    dispatch(UIActions.closeChangePassword());
  }

  function oldPasswordIsValid(): boolean {
    return values.oldPassword !== undefined && values.oldPassword !== "";
  }
  function newPasswordIsValid(): boolean {
    return values.newPassword !== undefined && values.newPassword !== "";
  }
  function confirmPasswordIsValid(): boolean {
    return (values.confirmPassword !== undefined
      && values.confirmPassword !== ""
      && values.confirmPassword === values.newPassword);
  }


  const isFormValid = () => {
    let isValid = true;
    if (values.newPassword && values.newPassword.trim().length < 8) {
      Swal.fire({
        icon: 'warning',
        title: 'Validar contraseña',
        text: 'La nueva contraseña debe tener al menos 8 caracteres'
      });
      isValid = false;
    } else if ((values.newPassword) && (!(/[a-z]/.test(values.newPassword)) || !(/[A-Z]/.test(values.newPassword)) || !(/[0-9]/.test(values.newPassword)))) {
      Swal.fire({
        icon: 'warning',
        title: 'Validar contraseña',
        html:
          'La contraseña debe tener al menos: ' +
          (!(/[a-z]/.test(values.newPassword)) ? '<li><b>una minúscula</b></li> ' : '') +
          (!(/[A-Z]/.test(values.newPassword)) ? '<li><b>una mayúscula</b></li> ' : '') +
          (!(/[0-9]/.test(values.newPassword)) ? '<li><b>un número</b></li> ' : '')
      });
      isValid = false;
    } else if (values.newPassword) {
      const passwordValidation = validatePassword(values.newPassword);
      if (!passwordValidation.isValid) {
        Swal.fire({
          icon: 'warning',
          title: 'Contraseña insegura',
          html: '<div style="text-align: left;">' + passwordValidation.errors.join('<br/>') + '</div>'
        });
        return false;
      }
    }
    return isValid
  }

  return (
    <Modal
      onHide={handleHide}
      show={uiState.isPasswordOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton
        className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Cambio de contraseña
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label>Contraseña actual</Form.Label>
            <InputMvv
              name="oldPassword"
              placeholder="Contraseña actual"
              handleInputChange={handleInputChange}
              value={values.oldPassword}
              showPasswordStrength={false}
              autoComplete="current-password"
            />
          </Form.Group>
          <div className="divider mb-2" />
          <Form.Group>
            <Form.Label>Nueva contraseña </Form.Label>
            <InputMvv
              name="newPassword"
              placeholder="Nueva contraseña"
              handleInputChange={handleInputChange}
              value={values.newPassword}
              showPasswordStrength={true}
              autoComplete="new-password"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirme nueva contraseña </Form.Label>
            <InputMvv
              name="confirmPassword"
              placeholder="Confirme nueva contraseña"
              handleInputChange={handleInputChange}
              value={values.confirmPassword}
              showPasswordStrength={false}
              autoComplete="new-password"
            />
          </Form.Group>
          <Button className="float-right mt-2" variant="primary" type="submit">
            Guardar
          </Button>
          <Button onClick={handleHide} className="float-right mt-2 mr-2" variant="secondary">
            Cancelar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
